//Copyright Open Trade Technology Ltd. 2023. All rights reserved.

import * as React from 'react'
import { ReactElement } from 'react'
import { Typography } from '@mui/material'

import { LocalizationProvider } from '@mui/x-date-pickers-pro'
import { DatePicker } from '@mui/x-date-pickers-pro'
import { AdapterDayjs } from '@mui/x-date-pickers-pro/AdapterDayjs'
import dayjs, { Dayjs } from 'dayjs'

// Import common DayJS locales
import 'dayjs/locale/en'
import 'dayjs/locale/pt-br'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/de'

import { logOT } from '@shared/loggingShared'

// Helper function to safely generate date format string
const getSafeDateFormatString = (locale: string): string => {
  try {
    const dateFormatOptions = Intl.DateTimeFormat(locale).formatToParts()
    const formatString = dateFormatOptions
      .map((part) => {
        switch (part.type) {
          case 'day':
            return 'DD'
          case 'month':
            return 'MM'
          case 'year':
            return 'YYYY'
          default:
            return part.value
        }
      })
      .join('')

    // Validate the format string is reasonable
    if (formatString && formatString.length > 2) {
      return formatString
    }
  } catch (error) {
    logOT.warn('Failed to generate date format for locale', locale, error)
  }

  // Fallback to standard format
  return 'DD/MM/YYYY'
}

// Helper function to get safe locale for DayJS
const getSafeLocale = (browserLocale: string): string => {
  const supportedLocales = ['en', 'pt-br', 'es', 'fr', 'de']
  const normalizedLocale = browserLocale.toLowerCase()

  // Direct match
  if (supportedLocales.includes(normalizedLocale)) {
    return normalizedLocale
  }

  // Try language code only (e.g., 'pt' from 'pt-BR')
  const languageCode = normalizedLocale.split('-')[0]
  if (supportedLocales.includes(languageCode)) {
    return languageCode
  }

  // Special case for Portuguese
  if (languageCode === 'pt') {
    return 'pt-br'
  }

  // Default fallback
  return 'en'
}

export default function EditDate(props: {
  propName: string
  label: string
  errors: any
  setValue: any
  register: any
  defaultValue: any
  onChange?: (e: Event) => void
}): ReactElement {
  const { propName, label, setValue, register, defaultValue, errors } = props
  // const castErrors = errors as Record<string, Error>
  logOT.info('Date defaultValue= ', propName, defaultValue, typeof defaultValue, register(propName))
  // const d = defaultValue as Date ?? new Date()
  //
  // let month = `${(d.getMonth() + 1)}`
  // let day = `${d.getDate()}`
  // const year = `${d.getFullYear()}`
  //
  // if (month.length < 2) { month = '0' + month }
  // if (day.length < 2) { day = '0' + day }
  //
  // const defaultValue2 = [year, month, day].join('-')

  logOT.debug('Edit date ', props.onChange)
  //  logOT.debug('Date defaultValue2', defaultValue2)

  // const localOnChange = (e: Event): void => {
  //   logOT.info('localOnChange', e)
  //   register(propName).onChange(e).then(() => {
  //     if (props.onChange) {
  //       logOT.info('localOnChange props.onChange', e)
  //       props.onChange(e)
  //     }
  //   })
  //     .catch((err: Error) => {
  //       logOT.error('err', err)
  //     })
  // }

  // return (
  //   <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
  //       <DateField label="Date" format="YYYY/MM/DD" defaultValue={dayjs('2022-04-17')} />
  //     </LocalizationProvider>
  // )
  logOT.info('lan ', window.navigator?.language)

  // Safe locale and date format handling
  const browserLocale = window.navigator?.language || 'en'
  const safeLocale = getSafeLocale(browserLocale)
  const dateFormatString = getSafeDateFormatString(browserLocale)

  logOT.info('Browser locale:', browserLocale, 'Safe locale:', safeLocale, 'Date format:', dateFormatString)

  return (
    <React.Fragment>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={safeLocale}>
        <DatePicker
          onChange={(newValue: Dayjs | null) => {
            const v = newValue?.format('YYYY-MM-DD ')
            setValue(propName, v)
            // register(propName).onChange(v).then(() => {
            //   if (props.onChange && v) {
            //     logOT.info('localOnChange props.onChange', v)
            //   //  props.onChange(v)
            //   }
            // })
          }}
          label={label}
          format={dateFormatString}
          defaultValue={dayjs(defaultValue)}
        />
      </LocalizationProvider>

      {/* <TextField */}
      {/* InputProps={{ */}
      {/*  onChange: localOnChange, */}
      {/*  format: 'yyyy' */}
      {/* }} */}
      {/* InputLabelProps={{ */}
      {/*  shrink: true */}
      {/* }} */}
      {/* inputProps={{ */}
      {/*  'data-testid': propName, */}
      {/*  format: 'yyyy-mm' */}
      {/* }} */}
      {/* defaultValue={defaultValue} */}
      {/* required */}
      {/* id={propName} */}
      {/* label={label } */}
      {/* fullWidth */}
      {/* format={'yyyy'} */}
      {/* type="date" */}
      {/* margin="dense" */}
      {/* {...register(propName)} */}
      {/* error={(castErrors[propName] != null)} */}
      {/* /> */}

      {/* <Controller */}
      {/*  as={DesktopDatePicker} */}
      {/*  name={propName} */}
      {/*  control={control} */}
      {/*  valueName={propName} */}
      {/*  {...register(propName)} */}
      {/*  error={(castErrors[propName] != null)} */}
      {/*  className="input" */}
      {/*  placeholderText="Select date" */}
      {/*  onChange={(select: any) => { */}
      {/*    logOT.debug('select', select) */}
      {/*  }} */}
      {/* /> */}
      {/* <DesktopDatePicker */}
      {/*  minDate={new Date()} */}
      {/*  id={propName} */}

      {/*  defaultValue={defaultValue} */}
      {/*  required */}
      {/*  fullWidth */}
      {/*  margin="dense" */}
      {/*  {...register(propName)} */}
      {/*  renderInput={(params) => { */}
      {/*    logOT.debug('params', params) */}
      {/*    logOT.debug('register(propName', register(propName)) */}
      {/*    // textField = (<TextField {...params} {...register(propName)} value={value}/>) */}
      {/*    const inputProps = { ...params.inputProps } */}
      {/*    // inputProps.type = 'date' */}
      {/*    textField = (<TextField InputProps={params.InputProps} */}
      {/*                            inputProps={inputProps} */}
      {/*                            inputRef = {params.inputRef} */}
      {/*                            ref = {params.ref} */}
      {/*                            InputLabelProps={{ */}
      {/*                              shrink: true */}
      {/*                            }} */}
      {/*                            error={false} */}
      {/*                            required */}
      {/*                            id={propName} */}
      {/*                            label={label} */}
      {/*                            fullWidth */}
      {/*                            margin="dense" */}
      {/*      {...register(propName)} */}
      {/*      /> */}
      {/*    ) */}
      {/*    return textField */}
      {/*  }} */}
      {/*  error={(castErrors[propName] != null)} */}
      {/*  onChange={(select) => { */}
      {/*    logOT.debug('select', select) */}
      {/*    setValue('startDate', select) */}
      {/*    logOT.debug('textField', textField) */}
      {/*    logOT.debug('register', register) */}
      {/*    logOT.debug('register(propName)', register(propName)) */}
      {/*    // register(propName).onChange({ target: { name: 'startDate' }, value: select }) */}
      {/*    return select */}
      {/*  }} */}
      {/* /> */}
      <Typography variant="inherit" color="textSecondary">
        {errors[propName]?.message}
      </Typography>
    </React.Fragment>
  )
}
